import { Skeleton } from '@/components/ui/skeleton';
import { Textarea } from '@/components/ui/textarea';
import { FieldComponentProps } from './types';

const FieldView = ({ value }: { value?: string | null }) => {
  if (value === null || value === undefined || value === '') {
    return <p className="text-muted-foreground">-</p>;
  }
  // A simple view for now, we can add markdown rendering later
  return <p className="whitespace-pre-wrap">{String(value)}</p>;
};

export const TextareaField = ({
  formMode,
  controllerField,
  field,
}: FieldComponentProps) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-16 w-full" />;
  }

  if (formMode === 'edit') {
    return (
      <Textarea
        {...controllerField}
        placeholder={field.meta.placeholder}
        className="min-h-10 py-1.5 text-sm"
        rows={2}
      />
    );
  }

  return <FieldView value={controllerField.value?.trim()} />;
};
